import { create } from 'zustand';

// Estado de sincronización offline — lo lee el indicador en el header
export const useSyncStore = create((set, get) => ({
  isOnline:       true,

  // Tramo caja ↔ nube. Lo reporta el hub sobre SU outbox.
  pendingCount:   0,   // jobs en la outbox pendientes de sync
  errorCount:     0,   // jobs con error permanente (necesitan revisión)

  // Tramo dispositivo ↔ caja. Lo reporta la outbox de ESTA tablet o celular.
  // Va aparte y no reutiliza los de arriba porque son cosas distintas y se
  // arreglan distinto: que la caja no alcance internet no es lo mismo que que
  // la orden del mesero no haya salido de su teléfono. Y lo segundo es más
  // urgente: esos platillos todavía no existen para nadie más.
  outboxCount:    0,
  outboxErrors:   0,

  lastSyncAt:     null,

  setOnline:   (v) => set({ isOnline: v }),
  setOutbox:   (pendientes, fallidas) => set({ outboxCount: pendientes, outboxErrors: fallidas }),
  setPending:  (n) => set({ pendingCount: n }),
  setErrors:   (n) => set({ errorCount: n }),
  setSyncedAt: ()  => set({ lastSyncAt: new Date().toISOString() }),
}));
